import React from 'react'
import FormControl from "@mui/material/FormControl"
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import {Context as AppContext} from "../contexts/App"

const VendorPicker = () => {
  const { warehouses, warehouse, warehouseChange } = React.useContext(AppContext).warehouses
  return (
    <React.Fragment>
        {!warehouse && "Selecciona el Almacén del que se enviará"}
        {warehouses && 
            <FormControl sx={{ m: 1, width: '25ch' }} >
                <InputLabel id={"label-vendor"}>Almacén</InputLabel>
                <Select
                    labelId="label-vendor"
                    name="vendor"
                    label="Almacén"
                    value={warehouse}
                    onChange={warehouseChange}
                    >
                    {warehouses.map(w => (
                        <MenuItem value={w.id}>{w.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        }
    </React.Fragment>
  )
}

export default VendorPicker